import { Copyright, FooterContainer } from './styles';

const Footer = () => (
  <FooterContainer>
    <Copyright>MKS sistemas &copy; Todos os direitos reservados</Copyright>
  </FooterContainer>
);

export default Footer;